





















// Composition
import { ref, defineComponent, useRouter, computed } from '@nuxtjs/composition-api'

// Store
import { useSearchStore } from '~/store/search'

// Composable
import useSearchUrl from '@/composables/search/useSearchUrl'
import useSearchAnalytics from '@/composables/analytics/useSearchAnalytics'
import { useCountry } from '@/composables/country/useCountry'

// Mapping
import { sortMapping } from '@/common/mapping/mapping'

// Components
import IconFaSolidAngleDown from '~icons/fa-solid/angle-down'

export default defineComponent({
  components: {
    IconFaSolidAngleDown,
  },

  setup() {
    const { isJapan } = useCountry()
    const searchStore = useSearchStore()
    const sortFieldName = computed<string>({
      get(): string {
        return searchStore.page.sortField
      },
      set(val: string): void {
        searchStore.setSortField(val)
      },
    })

    // local vars
    const sortOptions = Object.keys(sortMapping)
    const orderOptions = ['asc', 'desc']
    const selectedOrderOption = ref('asc')
    const { getSearchUrl } = useSearchUrl()
    const router = useRouter()
    const { trackSearchSorted } = useSearchAnalytics()

    // searchAfterSort
    const searchAfterSort = () => {
      // perform a new search
      router.push(getSearchUrl())

      // Send GTM event to store the order
      trackSearchSorted()
    }

    return {
      sortOptions,
      orderOptions,
      sortFieldName,
      selectedOrderOption,
      searchAfterSort,
      isJapan,
    }
  },
})
